import { render, staticRenderFns } from "./PrivacyAndPolicy.vue?vue&type=template&id=41b8fc27&"
import script from "./PrivacyAndPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivacyAndPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports